import React, { Component } from 'react'
// @ts-ignore
import ArrowLeft from 'react-icons/lib/md/keyboard-arrow-left'
// @ts-ignore
import ArrowRight from 'react-icons/lib/md/keyboard-arrow-right'
import cn from 'classnames'

// Types are not working for current react-icons version.We shoud migrate to v.3

import { iButtonArrowProps } from './interface';

import './styles.scss'

class ButtonArrow extends Component<iButtonArrowProps> {
  static defaultProps = {
    onClick: Function.prototype,
  }

  render() {
    const { buttonClass, left, right, onClick, style, iconProps, disabled } = this.props
    return (
      <button
        disabled={disabled}
        className={cn('base-arrow-button', buttonClass)}
        style={{ ...style, display: 'block' }}
        onClick={onClick}
      >
        {left ? (
          <ArrowLeft {...iconProps} />
        ) : right ? (
          <ArrowRight {...iconProps} />
        ) : (
              'left or right props is required'
            )}
      </button>
    )
  }
}

export default ButtonArrow
